export const MAX_IMAGE_SIZE = 6 * 1024 * 1024;
export const MAX_IMAGE_SIZE_LABEL = '6MB';

export const validateImageSize = (file, setErrors, setImage, setImagePreview) => {
  if (file.size > MAX_IMAGE_SIZE) {
    setErrors(prev => ({ ...prev, image: `Image must be smaller than ${MAX_IMAGE_SIZE_LABEL}` }));
    setImage(null);
    setImagePreview(null);
    return true;
  }
  setErrors(prev => ({ ...prev, image: '' }));
  return false;
};

export const isRealDate = (dateStr) => {
  if (!dateStr) return false;
  const dateObj = new Date(`${dateStr}T00:00:00Z`);
  if (isNaN(dateObj.getTime())) return false;
  const [y, m, d] = dateStr.split('-');
  return (
    parseInt(y) === dateObj.getUTCFullYear() &&
    parseInt(m) === dateObj.getUTCMonth() + 1 &&
    parseInt(d) === dateObj.getUTCDate()
  );
};

export const TIMELINE_CONFIG = {
  POINTS_PER_SCREEN: 20,
  ZOOM_IN_FACTOR: 0.8,
  ZOOM_OUT_FACTOR: 1.25,
  TRACK_HEIGHT: 50,
  TIMELINE_OFFSET: 42,
  BASE_LEG_HEIGHT: 16,
  DRAG_SPEED_MULTIPLIER: 1.5,
  MIN_CARD_SPACING: 20,
  DATE_CHAR_WIDTH: 6,
  DATE_LABEL_PADDING: 8,
  MIN_DATE_LABEL_WIDTH: 40,
  MIN_DATE_LABEL_GAP: 6,
  DATE_LABEL_BASE_OFFSET: 17,
  DATE_LABEL_STACK_OFFSET: 12,
};